export default function SettingsPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-white mb-2">Settings</h1>
      <p className="text-gray-400 text-sm mb-8">Configure platform settings — AI model, notifications, branding.</p>
      <div className="bg-gray-900 border border-dashed border-gray-700 rounded-xl p-12 text-center">
        <p className="text-gray-500 text-sm">This page is scaffolded and ready to build out in Phase 3.</p>
        <p className="text-gray-600 text-xs mt-1">See DEVELOPMENT_PLAN.md → Phase 3 for implementation details.</p>
      </div>
    </div>
  );
}
